import { filesApi } from '@/lib/api';
import { createFileOpenGuard } from './fileOpenSession';
import { spreadsheetSpecForFile } from './spreadsheetImportRecovery';

// Export the snapshot shown in the preview, never the editor's mutating export.
export async function prepareArtifactDownload(file, kind, documentSource, { isRequestCurrent } = {}) {
  const isCurrent = createFileOpenGuard(isRequestCurrent);
  if (!isCurrent()) return null;
  if (!['document', 'spreadsheet', 'presentation'].includes(kind)) return file;
  const id = file?.id || file?._id;
  if (!id) throw new Error('Missing artifact ID');
  try {
    let exported;
    if (kind === 'document') {
      if (!documentSource?.markdown) throw new Error('Document preview has not loaded');
      exported = await filesApi.exportEditableDocumentDocx(id, documentSource, { isRequestCurrent: isCurrent });
    } else {
      const spec = kind === 'spreadsheet' ? spreadsheetSpecForFile(file) : file?.parameters?.presentationSpec;
      if (!spec) throw new Error('Missing artifact source');
      exported = await filesApi.exportArtifactCopy(id, { kind, spec }, { isRequestCurrent: isCurrent });
    }
    return isCurrent() ? exported : null;
  } catch (error) {
    if (!isCurrent()) return null;
    throw error;
  }
}
